import { SubscriptionOptions } from '@reduxjs/toolkit/dist/query/core/apiState';
import { useState } from 'react';
import {
  PaginationQueryParams,
  UsePaginationLazyQuery,
  UsePaginationReturn1,
} from './types';
import usePagination from './usePagination';

export default function useLoadMorePagination<Q extends UsePaginationLazyQuery>(
  lazyQuery: Q,
  params: PaginationQueryParams<Q>,
  options: { skip?: boolean; skipQueryParamsCache?: boolean } = {
    skip: false,
    skipQueryParamsCache: false,
  },
  subscriptionOptions?: SubscriptionOptions,
) {
  const Pagination = usePagination(
    lazyQuery,
    params,
    options,
    subscriptionOptions,
  );

  const data = _.flatten(Pagination.allPages.map((x) => x.data));
  return {
    data,
    loadMore: () => Pagination.GetPage(Pagination.page + 1),
    refetch: Pagination.goToFirstPage,
    filters: Pagination.filters,
    isFetching: Pagination.isFetching,
    isLoading: Pagination.isLoading,
    setFilters: Pagination.setFilters,
    hasMore: data.length < Pagination.pagination.count,
    total: Pagination.pagination.count,
  };
}
